import React, { FunctionComponent } from 'react'
import Box from '@material-ui/core/Box'
import { SubscriptionOffersProvider } from 'SubscriptionOffers/SubscriptionOffersProvider'
import Message, { MessageProvider } from 'Elements/Message'
import Toolbar from 'SubscriptionOffers/partials/Toolbar'
import List from 'SubscriptionOffers/partials/List'

export type Props = {}
export type Functions = {}
export type AllProps = Props & Functions

const SubscriptionOffers: FunctionComponent<AllProps> = ({}) => {
  return (
    <Box p={1.5}>
      <SubscriptionOffersProvider>
        <MessageProvider>
          <Toolbar />
          <List />
          <Message />
        </MessageProvider>
      </SubscriptionOffersProvider>
    </Box>
  )
}

export default SubscriptionOffers
